"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessfulParseResultType = Symbol("SuccessfulParseResult");
exports.FailedParseResultType = Symbol("FailedParseResult");
exports.isFailedParseResult = (result) => {
    return result.type === exports.FailedParseResultType;
};
exports.isSuccessfulParseResult = (result) => {
    return result.type === exports.SuccessfulParseResultType;
};
//# sourceMappingURL=ParseResult.js.map